import { stateCodes } from "./addresses";

export const providerTraits = {
  gender: [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ],
  language: [
    { label: "English", value: "english" },
    { label: "Spanish", value: "spanish" },
  ],
  stateLicense: stateCodes.map(s => ({label: s, value: s})),
}